import { Bar } from 'react-chartjs-2';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { ChartData, ChartOptions } from 'chart.js';
import { NoData } from 'pages/Admin/Analytics/components/NoData/NoData';
import { SourceBadge } from 'pages/Admin/Analytics/components/SourceBadge/SourceBadge';
import { formatMonth } from 'pages/Admin/Analytics/utils/monthlySeries';
import { useGetMonthlySubscriptionActivity } from 'queryHooks/Admin/analytics';

const chartOptions: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: { boxWidth: 10, font: { size: 11 } },
    },
    tooltip: {
      callbacks: {
        label: (context) => `${context.dataset.label}: ${Math.abs(Number(context.raw ?? 0)).toLocaleString()}`,
      },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { font: { size: 11 } },
    },
    y: {
      grid: { color: 'rgba(0,0,0,0.06)' },
      ticks: { font: { size: 11 } },
    },
  },
};

export const SubscriptionActivityChart = () => {
  const { data, isLoading, isError } = useGetMonthlySubscriptionActivity();
  const hasData = Boolean(data?.length);

  const chartData: ChartData<'bar'> = {
    labels: data?.map((e) => formatMonth(e.year, e.month)) ?? [],
    datasets: [
      {
        label: 'New',
        data: data?.map((e) => e.newSubscriptions) ?? [],
        backgroundColor: 'rgba(34, 160, 90, 0.75)',
        borderRadius: 3,
      },
      {
        label: 'Cancelled',
        data: data?.map((e) => -e.cancellations) ?? [],
        backgroundColor: 'rgba(217, 48, 37, 0.7)',
        borderRadius: 3,
      },
    ],
  };

  return (
    <Paper className='analytics-card analytics-chart-card'>
      <div className='analytics-card__title-group'>
        <span className='card-title'>New subscriptions vs cancellations</span>
        <SourceBadge source='RECURLY' />
      </div>
      <p className='analytics-card__subtitle'>New subscriptions and cancellations by month.</p>

      {isLoading || isError || !hasData ? (
        <NoData loading={isLoading} error={isError} noData={!hasData} />
      ) : (
        <div className='analytics-chart-card__content'>
          <Bar data={chartData} options={chartOptions} />
        </div>
      )}
    </Paper>
  );
};

export default SubscriptionActivityChart;
